<template>
  <div class="nofif">
    <UploaderManyMedia
    v-if="edit"
    :modelValue="mediaData"
    :url="'product_media/'"
    :toAction="'addProduct'"
    @done="handleUploadResult" />
    <UploaderManyMedia
    v-else
    :url="'product_media/'"
    :toAction="'addProduct'"
    @done="handleUploadResult" />
  </div>
  <form @submit.prevent="submitForm">
    <div class="nofif">
      <label>اسم محل</label>
      <input v-model="form.title" type="text" required />
    </div>
    <div class="fif">
      <label>موجودی</label>
      <multiselect
        v-model="form.category_id"
        :options="categories"
        :multiple="true"
        track-by="id"
        label="title"
        placeholder="دسته‌بندی را انتخاب کنید"
        selectLabel="برای انتخاب این مورد، اینتر بزنید"
        selectedLabel="انتخاب شده"
        deselectLabel="برای حذف این مورد، کلیک کنید"
        noOptions="موردی برای انتخاب وجود ندارد"
        noResult="نتیجه‌ای با این جستجو پیدا نشد"
      />
    </div>
    <div class="fif">
      <label>محدوده</label>
      <multiselect
        v-model="form.filter_city"
        :options="city"
        :group-select="true"
        group-values="c"
        group-label="p"
        track-by="name" 
        label="name"
        :multiple="true"
        placeholder="محدوده سفارش را انتخاب کنید"
        selectLabel="برای انتخاب این مورد، اینتر بزنید"
        selectedLabel="انتخاب شده"
        deselectLabel="برای حذف این مورد، کلیک کنید"
        noOptions="موردی برای انتخاب وجود ندارد"
        noResult="نتیجه‌ای با این جستجو پیدا نشد"
      />
    </div>
    <div class="nofif">
      <label>آدرس تحویل</label>
      <textarea v-model="form.description" rows="4" required></textarea>
    </div>
    <button type="submit" :disabled="isSubmitDisabled">ثبت</button>
  </form>
</template>
<script setup>
  import { ref, onMounted, computed, watch, defineProps } from 'vue'
  import UploaderManyMedia from '@/components/tooles/upload/UploaderManyMedia.vue'
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import router from '@/router'
  import { useProductStore } from '@/stores/product'
  import { useAlertStore } from '@/stores/alert'
  const productStore = useProductStore()
  const alertStore = useAlertStore()
  const city = ref([])
  const categories = ref([])
  const data = ref(null)
  const mediaData = ref(null)
  const props = defineProps({
    edit:{
      type:Boolean,
      default:false
    },
    id:{
      type:Number,
      default:0
    }
  })
  const edit = computed(()=>{ return props.edit })
  const form = ref({
    category_id: [],
    media_id: [],
    filter_city:[],
    title: '',
    do_type: 'task',
    description: '',
  })
  const handleUploadResult = (uploadedData) => {
    form.value.media_id = uploadedData.map(item => item.id)
  }
  const isSubmitDisabled = computed(() => {
    const isTitleEmpty = !form.value.title.trim()
    const isDescriptionEmpty = !form.value.description.trim()
    const isCategoryInvalid = !form.value.category_id || form.value.category_id.length === 0
    return isDescriptionEmpty || isCategoryInvalid || isTitleEmpty 
  })
  const submitForm = async () => {
    let finalData = {
      ...form.value,
      category_id: form.value.category_id.map(c => c.id),
      filter_city: form.value.filter_city.map(c => c.id),
    }
    if(edit.value){
      finalData = {
        ...finalData,
        id:data.value?.id
      }
    }
    const res = edit.value ? await productStore.editProduct(finalData) : await productStore.addProduct(finalData)
    if(res) router.push({ path:'/manage-product' });
    else alertStore.msg='خطا در ثبت: ';
  }
  watch(data,(d)=>{
    if(d){
      mediaData.value=d?.medias
      form.value.title=d?.title??''
      form.value.description=d?.description??''
      form.value.category_id=d?.category??[]
      form.value.filter_city=d?.filter.map(({id,city}) => ({id:parseInt(id),name:city}))??[]
      form.value.media_id=d?.medias.map(m => parseInt(m.id))??[]
      if(d.medias.length > 0) mediaData.value = d.medias
    }
  })
  onMounted(async () => {
    const res = await productStore.addProductData()
    categories.value = res.category
    city.value = res.city 
    if(edit.value){
      const fet = props.id > 0 ? await productStore.fetchProductById(props.id) : null;
      if(fet && fet.length > 0 && fet['0']){
        data.value = fet['0'];
      }else{
        data.value = null;
      }
    }
  })
</script>
<style scoped>
  form {
    direction: rtl;
  }
  form > div {
    margin-top: 10px;
  }
  textarea , input {
    outline: none;
    border-radius: 5px;
    width: 100%;
    padding: 0.5rem;
    box-sizing: border-box;
    border: none;
    box-shadow: 1px 1px 4px grey;
  }
  label{
    margin-bottom: 0.5rem;
    display: block;
  }
  .fif{
    width: 46%;
    display: inline-block;
    margin: 5px 2%;
  }
  .nofif{
    width: 96%;
    margin: 5px 2%;
  }
  .r{
    float: right;
  }
  button {
    padding: 0.5rem 1rem;
    background-color: #10b981;
    color: white;
    border: none;
    border-radius: 0.375rem;
    cursor: pointer;
    width: 100%;
    margin-top: 1rem;
    transition: background-color 0.2s ease, opacity 0.2s ease;
  }
  button:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
    opacity: 0.6;
  }
  @media screen and (max-width:500px) {
    .fif{
      width: 96%;
    }
    .nochng{
      width: 46% !important;
    }
    .r{
      float: unset;
    }
  }
</style>
<style>
  .multiselect__tags {
    overflow-y: auto;
    max-height: 140px;
  }
</style>